"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteEpochPoolStatsListSchema = exports.VoteEpochPoolStatsSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
const VoteEpoch_1 = require("./VoteEpoch");
exports.VoteEpochPoolStatsSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
    epochID: zod_1.z.number().int().min(0),
    tvl: core_contracts_ifaces_1.TokenAmountSchema,
    fees: zod_1.z.object({
        total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
        items: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
    }),
    incentives: zod_1.z.object({
        total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
        items: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
    }),
    apr: zod_1.z.number(),
    vote: VoteEpoch_1.VoteEpochSchema,
});
exports.VoteEpochPoolStatsListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.VoteEpochPoolStatsSchema),
});
